import { styled } from '@mui/system';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import type { IData } from 'Components/DashboardTile/TileContentMaker/components/definitions';
import { fm } from 'Components/FormatMessage';
import { isPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import * as React from 'react';

const MainTitle = styled('div')({
  fontSize: '1.8rem',
  fontWeight: 600,
});
const MainValue = styled('div')({
  fontSize: '1.8rem',
  fontWeight: 600,
});
const Title = styled('div')({
  marginTop: '0.5rem',
});
const Value = styled('div')({
  marginTop: '0.5rem',
});

const ThalamotomyHifuDash = ({ documents }: IOwnProps): React.JSX.Element | undefined => {
  const dashData: IData[] = [];
  documents.forEach((d, i) => {
    dashData.push({
      date: isPartialDate(d.date) ? formatPartialDate(d.date) : undefined,
      title: (
        <>
          <MainTitle>{fm(`thalamotomyHifu.${d._type}.title`)}</MainTitle>
          <Title>{d._type === 'thalamotomy' ? fm('thalamotomyHifu.thalamotomy.treatmentType') : ''}</Title>
          <Title>{d._type === 'hifu' && d.treatmentTarget ? fm('thalamotomyHifu.hifu.treatmentTarget') : ''}</Title>
        </>
      ),
      value: (
        <>
          <MainValue>&nbsp;</MainValue>
          <Value>
            {d._type === 'thalamotomy' && d.typeOfOperation
              ? fm(`thalamotomyHifu.thalamotomy.opts.${d.typeOfOperation}`)
              : ''}
          </Value>
          <Value>
            {d._type === 'hifu' && d.treatmentTarget ? fm(`thalamotomyHifu.hifu.opts.${d.treatmentTarget}`) : ''}
          </Value>
        </>
      ),
      key: `thalamotomyHifu${i}`,
    });
  });

  return <TileContentMaker type="specificListMultipleRows" itemsCanFitAmount={2} data={dashData} />;
};

interface IOwnProps {
  documents: IDocumentWithTypeV2<'thalamotomy' | 'hifu'>[];
}

export default ThalamotomyHifuDash;
